<template>
  <table class="m-table StudentForm">
    <tbody>
      <tr>
        <th colspan="2">family_id</th>
        <td colspan="10"><input type='text' required v-model="student.family_id" placeholder="Family ID" readonly></td>
      </tr>
      <tr>
        <th colspan="2">名前</th>
        <td colspan="2"><input type='text' v-model="student.f_name" placeholder="姓" @keypress.self.prevent.13></td>
        <td colspan="2"><input type='text' v-model="student.l_name" placeholder="名" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">かな</th>
        <td colspan="2"><input type='text' required v-model="student.f_name_kana" placeholder="せい" @keypress.self.prevent.13></td>
        <td colspan="2"><input type='text' required v-model="student.l_name_kana" placeholder="めい" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">性別</th>
        <td colspan="4"><multiselect v-model="watch.gender" :options="gender" label="name" :searchable="false" :show-labels="false" placeholder="性別"></multiselect></td>
        <th colspan="2" class="req">生年月日</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="student.birthday" placeholder="生年月日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">年齢</th>
        <td colspan="4"><div class="calc">{{calcAge}}</div></td>
        <th colspan="2">公/国/私</th>
        <td colspan="4"><multiselect v-model="watch.school_type" :options="school_type" label="name" :searchable="false" :show-labels="false" placeholder="公/国/私"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">学年</th>
        <td colspan="2"><div class="calc">{{calcGrade}}</div></td>
        <td colspan="2"><input type='number' v-model="student.grade_flag" placeholder="留年・浪人" @keypress.self.prevent.13></td>
        <th colspan="2">学校名</th>
        <td colspan="4"><input type='text' v-model="student.school_name" placeholder="学校名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">次回引継時期</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="student.takeover_time" placeholder="次回引継時期" @keypress.self.prevent.13></td>
        <th colspan="2">指導詳細</th>
        <td colspan="4"><input type='text' v-model="student.guidance_detail" placeholder="指導詳細" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">優先度</th>
        <td colspan="4"><multiselect v-model="watch.priority" :options="priority" label="name" :searchable="false" :show-labels="false" placeholder="優先度"></multiselect></td>
        <th colspan="2" class="req">役務期間</th>
        <td colspan="2"><input type="text" required maxlength="10" minlength="10" v-model="student.service_period_start" placeholder="役務開始" @keypress.self.prevent.13></td>
        <td colspan="2"><input type="text" required maxlength="10" minlength="10" v-model="student.service_period_end" placeholder="役務終了" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">備考</th>
        <td colspan="10"><textarea v-model="student.note" placeholder="備考"></textarea></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
// import { getAPIURL } from '@/store/getters.js'
// const url = getAPIURL() + '/api/v1/students/'

export default {
  props: {
    student: Object,
    watch: Object
  },
  data () {
    return {
    }
  },
  computed: {
    gender () {
      return this.$store.getters['students/gender']
    },

    school_type () {
      return this.$store.getters['students/school_type']
    },

    priority () {
      return this.$store.getters['students/priority']
    },

    calcAge () {
      let x = Date.parse(this.student.birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade () {
      let self = this
      let x = Date.parse(self.student.birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(self.student.grade_flag)

      // 月だけ0から始まるので4月は3
      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else {
        grade = ''
      }
      return grade
    }
  },
  methods: {
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.req {
  /* background: #dffbef; */
  background: #41b883;
}
table {
  border-spacing: 0;
  width: 100%;
  border-top: solid 1px #ddd;
  tr {
    th {
      /* border-bottom: solid 1px #ddd; */
      /* background: #f4f4f4; */
      background: #37474f;
      /* color: #333; */
      color: #fbfbfb;
      padding: .5rem;
      font-weight: normal;
      font-size: .85rem;
    }
    td {
      border-bottom: solid 1px #ddd;
      border-right: solid 1px #ddd;
      input, textarea, .calc {
        outline: 0;
        border: none;
        width: 100%;
        padding: .5rem;
        font-size: .85rem;
        &:focus {
          background: #cdeeff;
        }
      }
      textarea {
        height: 150px;
        &:focus {
          background: #cdeeff;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.StudentForm {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// StudentForm.vue?5f61b919